import React from 'react';
import styled from 'styled-components';

import TextField from './TextField';

const Container = styled.div`
  position: relative;
`;
const StyledInput = styled(TextField)`
  width: 110px;
  padding-left: 20px;
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;
  
  @media (max-width: 480px) {
    width: 100px;
  }
`;

const CurrencyLabel = styled.div`
  position: absolute;
  right: 17px;
  top: 0;
  line-height: 64px;
  color: #999;
`;

const CurrencyInput = (props) => (
  <Container>
    <StyledInput
      type={props.type}
      placeholder={props.placeholder}
      {...props}>
      {props.children}
    </StyledInput>
    <CurrencyLabel>
      {props.currency}
    </CurrencyLabel>
  </Container>);

export default CurrencyInput;


// WEBPACK FOOTER //
// ./src/Components/CurrencyInput.js